import { anyApi } from "convex/server";

// Frontend code only needs Convex function references at runtime. Importing the
// generated typed API from ../../convex/_generated/api makes tsc follow every
// Convex server module during the React build, so keep this client boundary
// intentionally untyped.
export const api = anyApi as any;
